export default {
  logLengths: [],
  lengthGroups: [],
  accountIdOfLengthGroups: null,
  diameterGroups: [],
  accountIdOfDiameterGroups: null,
  speciesGroups: []
}
